import React, { useEffect, useState } from "react";
import { FaCar, FaMobileAlt, FaSimCard, FaLaptop, FaThLarge, FaPlus, FaSearch } from "react-icons/fa";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import {
  LOGOUTLOADER,
  Logout,
  POPUP,
  SINGLEASSET,
  deleteAsset,
  getAssetTypebyid,
  getstatsassets,
  refreshToken,
} from "../../Actions/actions";
import { useDispatch } from "react-redux";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { useSelector } from "react-redux";
import AssetCreationModal from "../../Components/AssetReportModel/AssetCreationModal";
import { MdDelete, MdEdit } from "react-icons/md";
import ConfirmDeleteModal from "../../Components/ConfirmDeleteModal/ConfirmDeleteModal";
import { toast } from "react-toastify";
import { subscriptionsCondition } from "../../Reducers/reducers";
import CustomToast from "../../Components/CustomToast/CustomToast";
import { useNavigate } from "react-router-dom";

const Card = ({ icon: Icon, count, label }) => (
  <div className="bg-white py-4 w-[48%] md:w-[30%] lg:w-[18%] rounded-xl shadow-md flex flex-col items-center mb-[30px]">
    {/* min-w-[160px]  */}
    <Icon className="text-red-500 w-12 h-12 mb-2" />
    <p className="xl:text-xl sm:text-lg font-public font-bold text-gray-900">{count}</p>
    <p className="xl:text-sm sm:text-xs font-public font-bold text-gray-500">{label}</p>
  </div>
);

const CardList = () => {
  const dispatch = useDispatch();
  const [cards, setcards] = useState([]);

  const { loginData, assetstats } = useSelector((state) => state.userReducer);

  useEffect(() => {
    dispatch(getstatsassets(loginData?.accessToken));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const Cars = assetstats.assetTypes?.find((item) => item.assetType === "Cars");
    const Mobiles = assetstats.assetTypes?.find((item) => item.assetType === "Mobiles");
    const SimCards = assetstats.assetTypes?.find((item) => item.assetType === "Sim Cards");
    const Laptops = assetstats.assetTypes?.find((item) => item.assetType === "Laptops");
    // const FuelConsumption = assetstats.assetTypes?.find(item => item.assetType === 'Fuel Consumption')

    let asset = [
      { icon: FaCar, count: Cars?.count ? Cars?.count : 0, label: "Cars" },
      { icon: FaMobileAlt, count: Mobiles?.count ? Mobiles?.count : 0, label: "Mobiles" },
      { icon: FaSimCard, count: SimCards?.count ? SimCards?.count : 0, label: "Sim Cards" },
      { icon: FaLaptop, count: Laptops?.count ? Laptops?.count : 0, label: "Laptops" },
      // { icon: FaGasPump, count: FuelConsumption?.count ? FuelConsumption?.count : 0, label: "Fuel Consumption" },
    ];
    setcards(asset);
  }, [assetstats]);

  return (
    <div className="flex w-full flex-wrap justify-between  ">
      {cards.map((card, index) => (
        <Card {...card} />
      ))}
    </div>
  );
};

const TabMenu = ({ activeTab, setActiveTab, getAssets }) => {
  const tabs = [
    { label: "All", icon: FaThLarge, lab: "All" },
    { label: "Cars", icon: FaCar, lab: "Cars" },
    { label: "Mobiles", icon: FaMobileAlt, lab: "Mobile" },
    { label: "Sim Cards", icon: FaSimCard, lab: "Sim Card" },
    { label: "Laptops", icon: FaLaptop, lab: "Laptop" },
    // { label: "Fuel Consumption", icon: FaGasPump, lab: 'Fuel Consumption' },
  ];

  const handleTabClick = (label) => {
    setActiveTab(label);
  };

  return (
    <div className="flex flex-wrap  ">
      {tabs.map((tab, index) => (
        <button
          key={index}
          onClick={() => handleTabClick(tab.label)}
          className={`flex text-gray-400  items-center px-4 py-2 rounded-lg ${
            activeTab === tab.label ? "underline text-[grey]" : ""
          }`}
          style={{ color: activeTab === tab.label ? "black" : "gray" }}
        >
          <tab.icon className="mr-2" />
          {tab.label}
        </button>
      ))}
    </div>
  );
};

const TableComponent = ({
  data,
  activeTab,
  setEdit,
  setIsModalOpen,
  deleteid,
  setdeleteid,
  showDeleteModal,
  PrivilagesArray,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    filterData(searchTerm, activeTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchTerm, activeTab]);

  const handleSearch = (e) => {
    const value = e.target?.value?.toLowerCase();
    setSearchTerm(value);
  };

  const filterData = (searchTerm, tab) => {
    let filtered = data;
    if (tab !== "All") {
      filtered = filtered?.filter((item) => item?.assetType?.toLowerCase() === tab?.toLowerCase());
    }

    // Search filter
    if (searchTerm) {
      filtered = filtered?.filter(
        (item) =>
          item?.assetType?.toLowerCase()?.includes(searchTerm) ||
          item?.assetId?.toLowerCase()?.includes(searchTerm) ||
          item?.description?.toLowerCase()?.includes(searchTerm) ||
          item?.manufacturer?.toLowerCase()?.includes(searchTerm) ||
          item?.modelNumber?.toLowerCase()?.includes(searchTerm)
      );
    }

    setFilteredData(filtered);
  };

  const dispatch = useDispatch();
  const { loginData } = useSelector((state) => state.userReducer);

  return (
    <div className="rounded-lg shadow-md bg-white relative">
      <div className="rounded-lg p-4 flex space-x-6 items-center">
        <div className="relative w-[100%]">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search"
            className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>

        {/* Export Button */}
        {/* <button
                    className="flex row  items-center px-4 py-2 bg-[white] text-black rounded-lg hover:underline transition"
                    onClick={exportToExcel}
                >
                    <FaDownload className="mr-3 text-black" />

                    Export
                </button> */}
      </div>
      <div className="overflow-x-auto">
        <div className="min-w-full inline-block align-middle">
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full text-left">
              <thead className="bg-[#361D3214]">
                <tr className="text-gray-500 text-sm">
                  <th className="px-4 py-4 text-gray-600 font-semibold text-sm min-w-[140px]">Asset Type</th>
                  <th className="px-4 py-4 text-gray-600 font-semibold text-sm min-w-[140px]">Asset ID</th>
                  <th className="px-4 py-4 text-gray-600 font-semibold text-sm min-w-[150px]">Description</th>
                  <th className="px-4 py-4 text-gray-600 font-semibold text-sm min-w-[120px] text-center">
                    Manufacturer
                  </th>
                  <th className="px-4 py-4 text-gray-600 font-semibold text-sm min-w-[150px] text-center">
                    Model Number
                  </th>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px] text-center">Action</th>
                </tr>
              </thead>
              <tbody className="text-sm text-gray-800">
                {filteredData?.length > 0 ? (
                  filteredData?.map((item, index) => (
                    <tr key={index} className="border-t">
                      <td className="px-4 py-3">
                        {item?.assetType === "Cars"
                          ? "Car"
                          : item?.assetType === "Mobiles"
                          ? "Mobile"
                          : item?.assetType === "Sim Cards"
                          ? "Sim Card"
                          : item?.assetType === "Laptops"
                          ? "Laptop"
                          : item?.assetType}
                      </td>
                      <td className="px-4 py-3">{item?.assetId}</td>
                      <td className="px-4 py-3">{item?.description}</td>
                      <td className="px-4 py-3 text-center">
                        {item?.assetType === "Sim Cards" ? item?.networkProvider : item?.manufacturer}
                      </td>
                      <td className="px-4 py-3 text-center">
                        {item?.assetType === "Sim Cards" ? item?.phoneNumber : item?.modelNumber}
                      </td>
                      <td className="py-3 flex gap-3 justify-center">
                        {PrivilagesArray?.length > 0 ? (
                          PrivilagesArray[0].accessLevel !== "View Only" ? (
                            <button
                              className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                              onClick={() => {
                                dispatch(
                                  getAssetTypebyid(loginData?.accessToken, item?.id, () => {
                                    setEdit(true);
                                    setIsModalOpen(true);
                                  })
                                );
                              }}
                            >
                              <MdEdit size={18} />
                            </button>
                          ) : null
                        ) : (
                          <button
                            className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                            onClick={() => {
                              dispatch(
                                getAssetTypebyid(loginData?.accessToken, item?.id, () => {
                                  setEdit(true);
                                  setIsModalOpen(true);
                                })
                              );
                            }}
                          >
                            <MdEdit size={18} />
                          </button>
                        )}

                        {PrivilagesArray?.length > 0 ? (
                          PrivilagesArray[0].accessLevel === "Full Access" ? (
                            <button
                              className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                              onClick={() => {
                                setdeleteid(item?.id);
                                showDeleteModal(true);
                              }}
                            >
                              <MdDelete size={18} />
                            </button>
                          ) : null
                        ) : (
                          <button
                            className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                            onClick={() => {
                              setdeleteid(item?.id);
                              showDeleteModal(true);
                            }}
                          >
                            <MdDelete size={18} />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      No results found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const AssetCreation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, Privilages } = useSelector((state) => state.userReducer);
  const [activeTab, setActiveTab] = React.useState("All");
  // const [searchTerm, setSearchTerm] = React.useState("");
  const [edit, setEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [change, setchange] = useState(false);
  const [allAsset, setAllAsset] = useState([]);
  const [isOpenDeleteModal, showDeleteModal] = useState(false);
  const [deleteid, setdeleteid] = useState("");

  const getAsset = () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/asset-types`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          dispatch({ type: LOGOUTLOADER, payload: true });
          console.log(result);
          setAllAsset(result?.assetTypes);
          dispatch({ type: LOGOUTLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOGOUTLOADER, payload: false });
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(getstatsassets(loginData?.accessToken));

    getAsset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [change]);

  const PrivilagesArray = Privilages?.length > 0 ? Privilages.filter((item) => item.feature === "User Management") : [];

  return (
    <ParentComponent>
      <PrimaryHeader
        PrivilagesCondition={
          PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel === "Full Access" ? true : false) : true
        }
        PrivilagesConditionAsset={
          PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel === "Full Access" ? false : true) : false
        }
        buttonText="Add New Asset"
        buttonIcon={<FaPlus className="mr-2" />}
        buttonTextfirst="Assets Management"
        onButtonClickfirst={true}
        onfirstButtonClick={() => {
          navigate("/assets-management");
        }}
        onButtonClick={() => {
          subscriptionsCondition(
            loginData?.clientData?.subscriptionType,
            () => {
              if (allAsset?.length >= 5) {
                toast.success(
                  <CustomToast type={"Warn"} message={"Only 5 assets allowed.Change Plan for creating more assets."} />,
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    icon: false,
                    closeButton: false,
                  }
                );
              } else {
                dispatch({
                  type: SINGLEASSET,
                  payload: {},
                });
                setIsModalOpen(true);
              }
            },
            () => {
              if (allAsset?.length >= 100) {
                toast.success(
                  <CustomToast
                    type={"Warn"}
                    message={"Only 100 assets allowed.Change Plan for creating more assets."}
                  />,
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    icon: false,
                    closeButton: false,
                  }
                );
              } else {
                dispatch({
                  type: SINGLEASSET,
                  payload: {},
                });
                setIsModalOpen(true);
              }
            },
            () => {
              dispatch({
                type: SINGLEASSET,
                payload: {},
              });
              setIsModalOpen(true);
            }
          );
        }}
      />
      <div></div>
      <CardList />
      <TabMenu activeTab={activeTab} setActiveTab={setActiveTab} getAssets={getAsset} />
      <TableComponent
        data={allAsset}
        activeTab={activeTab}
        setEdit={setEdit}
        setIsModalOpen={setIsModalOpen}
        deleteid={deleteid}
        setdeleteid={setdeleteid}
        showDeleteModal={showDeleteModal}
        PrivilagesArray={PrivilagesArray}
      />
      <AssetCreationModal
        isOpen={isModalOpen}
        heading={edit ? "Assign Asset" : "Create Asset"}
        need={true}
        edit={edit}
        setEdit={setEdit}
        setchange={setchange}
        change={change}
        onClose={() => {
          setIsModalOpen(false);
          dispatch({
            type: SINGLEASSET,
            payload: {},
          });
          setEdit(false);
        }}
      />
      <ConfirmDeleteModal
        isOpen={isOpenDeleteModal}
        onClose={() => {
          showDeleteModal(false);
        }}
        onConfirm={() => {
          dispatch(
            deleteAsset(
              deleteid,
              () => {
                showDeleteModal(false);
                setchange(!change);
              },
              loginData?.accessToken,
              showDeleteModal
            )
          );
        }}
      />
    </ParentComponent>
  );
};

export default AssetCreation;
